<template>
  <div class="controlBox">
    <h5 class="title">{{ title }}</h5>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class controlBox extends Vue {
  @Prop(String) title;
}
</script>

<style lang="scss" scoped>
  .controlBox {
    background: #fff;
    padding: 15px;
    position: absolute;
    top: 0;
    right: -20px;
    width: 500px;
    transform: translateX(100%);
    border: 1px solid $border-light;
    margin-bottom: 30px;

    .title {
      font-size: 16px;
      margin: 0 0 15px;
    }
  }
</style>
